import { SharedAppConstants } from '@tock/shared-app-constants';
import { UserConsentLevel } from '../utils/cookieConsentUtils';

export function updateCookieConsentLevel(consentLevels: UserConsentLevel[]): BaseTockAction {
  return {
    type: SharedAppConstants.COOKIE_CONSENT_LEVEL_UPDATE,
    payload: consentLevels,
  };
}

export function updateScriptLoad(scriptsLoaded: boolean): BaseTockAction {
  return {
    type: SharedAppConstants.SCRIPT_LOAD_UPDATE,
    payload: scriptsLoaded,
  };
}
